// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__-4t24","list":"BalanceDue_list__2J7-k","listRow":"BalanceDue_listRow__3vyj9","total":"BalanceDue_total__XM6k0"};